<template>
  <SimpleFormModal
    ref="simpleFormModal"
    :form="form"
  />
</template>

<script>
import HttpStatus from 'http-status-codes'
import SimpleFormModal from '@/controls/SimpleFormModal'
import i18n from '@/utils/i18n'
import { createBuilding } from '@/api/buildings/request'
import navigation from '@/utils/navigation'
import { ROUTER_PATHS } from '@/constants/router'

export default {
  name: 'AddBuildingModal',
  components: {
    SimpleFormModal,
  },
  data () {
    return {
      form: [
        {
          type: 'text',
          name: 'code',
          label: i18n.t('settings.building.buildingName'),
          value: '',
          required: true,
        },
        {
          type: 'text',
          name: 'fullName',
          label: i18n.t('settings.building.buildingDesc'),
          value: '',
          required: true,
        },
      ],
    }
  },
  methods: {
    open () {
      let self = this
      this.$refs.simpleFormModal.open().setConfirmCallback(async data => {
        try {
          const buildingInformation = await createBuilding(data)
          self.$refs.simpleFormModal.close()
          if (buildingInformation) {
            navigation.toPage(ROUTER_PATHS.BUILDING_PROFILE, { id: buildingInformation.id })
          }
        } catch (err) {
          const response = err.response
          if (response.status >= HttpStatus.BAD_REQUEST) {
            this.$refs.simpleFormModal.setErrHint(`${i18n.t('error.duplicatedBuildingInput')}`)
          }
        }
      })
    },
  },
}
</script>
